<template>
  <section class="user-verify">
    <section v-if="verify">
      <h2 class="label success">Success.</h2>
      <p>Congratulation on your successful registration!</p>
      <p>
        Please wait for our manager to communicate with you.
        <br />
        And Please keep the communication unblocked.
        <br />
        <br />
        Automatically jump after 3S...
      </p>
    </section>

    <section v-else>
      <h2 class="label error">Sorry.</h2>
      <p>This authentication link is invalid.</p>
      <p>
        Please
        <router-link to="/aff-login">login</router-link>
        and get a new authentication email.
      </p>
    </section>
    <router-link to="/aff-login" class="mt-8"><el-button>Go and Login</el-button></router-link>
  </section>
</template>

<script>
export default {
  name: 'user-verify',
  created() {
    setTimeout(() => {
      this.routerChange('aff-login')
    }, 3000)
  },
  data() {
    return {
      verify: Number(this.$route.query.verify),
    }
  },
}
</script>

<style lang="scss">
.user-verify {
  width: 450px;
  margin: 0 auto;
  line-height: 1.5;
}
</style>
